import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, filter, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {AuthUntilUserRoleService} from '../../core/authentication/auth-until-user-role.service';
import {LearningPackageStudyProgressResponseDto} from '../../../../../micromate-learn-lib/src/lib/types/LearningPackageStudyProgressResponseDto';
import {TabEventType} from '../../../../../micromate-learn-lib/src/lib/services/event/TabEventType';
import {
    StudyProgressRessource
} from '../../../../../micromate-learn-lib/src/lib/services/rest/study-progress-ressource.service';
import {EventRecorderService} from '../../../../../micromate-learn-lib/src/lib/services/event/event-recorder.service';
import {
    LearnLearningPackageService
} from '../../../../../micromate-learn-lib/src/lib/services/learn-learning-package.service';
import {ErrorNotificationService} from '../../core/error-notification.service';

@Component({
    selector: 'mm-learning-study-progress',
    templateUrl: './learning-study-progress.component.html',
    styleUrls: ['./learning-study-progress.component.scss'],
    standalone: false
})
export class LearningStudyProgressComponent implements OnInit, OnDestroy {
    public studyProgresses: BehaviorSubject<LearningPackageStudyProgressResponseDto[] | undefined> = new BehaviorSubject<LearningPackageStudyProgressResponseDto[] | undefined>(undefined);
    public studyProgresses$ = this.studyProgresses.pipe(filter((value): value is LearningPackageStudyProgressResponseDto[] => value !== undefined));
    public paramsSubscription: Subscription | undefined;
    private learnerId: string | undefined;
    private openInConversation: boolean = false;

    constructor(private activatedRoute: ActivatedRoute,
                private studyProgressService: StudyProgressRessource,
                private authUntilUserRoleService: AuthUntilUserRoleService,
                private router: Router,
                private eventRecorderService: EventRecorderService,
                private learnLearningPackageService: LearnLearningPackageService,
                public errorNotificationService: ErrorNotificationService) {
    }

    public ngOnInit(): void {
        this.paramsSubscription = this.activatedRoute.queryParamMap.pipe(
            map(params => {
                this.learnerId = params.get('learnerid') ?? undefined;
                this.openInConversation = params.get('openInConversation') === 'true';
            }))
            .subscribe(async () => {
                await this.getStudyProgress();
                await this.recordTabEvent();
            });
    }

    public ngOnDestroy(): void {
        if (this.paramsSubscription !== undefined) {
            this.paramsSubscription.unsubscribe();
        }
    }

    private async getStudyProgress(): Promise<void> {
        if (this.learnerId === undefined) {
            const studyProgressesData = await this.studyProgressService.getLearnerStudyProgressForLearn();
            this.studyProgresses.next(studyProgressesData === undefined ? [] : studyProgressesData);
        } else {
            const isAdmin = await this.authUntilUserRoleService.assertAdmin().toPromise();
            if (isAdmin !== true) {

                void this.router.navigate(['/learn']);
            } else {
                const studyProgressesData = await this.studyProgressService.getLearnerStudyProgressForLearn(this.learnerId);
                this.studyProgresses.next(studyProgressesData === undefined ? [] : studyProgressesData);
            }
        }
    }

    private async recordTabEvent(): Promise<void> {
        await this.eventRecorderService.recordTabOpenedEventForLearn(this.learnerId, TabEventType.TabLearningProgressOpened, this.eventRecorderService.createTabOpenEventPayloadForLearn(this.openInConversation));
    }

    public async learnPackage(learningPackageId: string): Promise<void> {
        await this.learnLearningPackageService.learn(learningPackageId);
    }
}
